/* import __COLOCATED_TEMPLATE__ from './app-inserter.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency-decorators';
import { action } from '@ember/object';

export default class AppInserter extends Component {
  @service contentEditorService;
  @service store;

  @tracked messengerApps = [];

  constructor() {
    super(...arguments);
    this.fetchMessengerApps.perform();
  }

  @action
  createBlock(type, args) {
    let block = Object.assign({}, { type }, args);
    this.args.selectApp(block);
  }

  @task({ drop: true })
  *fetchMessengerApps() {
    let messengerApps = yield this.store.query('messenger-app', { restrict_to: 'messages' });
    this.messengerApps = messengerApps;
  }

  get inserterApi() {
    return { createBlock: this.createBlock };
  }
}
